<template>
  <div id="connection-details">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide>
        <div class="contents-container">
          <div class="contents">
            <div class="container">
              <div class="profile-container">
                <div class="photo" :style="updateMyPhotoView()"></div>
                <div class="photo char" :style="updatePartnerPhotoView()"></div>
                <div class="name">{{ userName }}</div>
                <div class="type" :class="`${typeColor}`">{{ userType }}</div>
              </div>
              <div class="desc"><span v-html="content"></span></div>
            </div>
          </div>
          <div class="padding-area"></div>
        </div>
      </swiper-slide>
      <swiper-slide v-for="(item, index) in detailList" :key="index">
        <div class="contents-container">
          <div class="contents">
            <div class="container">
              <h4 class="custom-for-connections">{{ item.title }}</h4>
              <div class="ind">
                <div class="profile-wrapper">
                  <div
                    class="profile profile-left"
                    :style="{ left: item.myPosition + '0%' }"
                  >
                    <div class="photo" :style="updateMyPhotoView()"></div>
                    <div class="score">{{ item.myPosition }}</div>
                  </div>
                </div>
                <div class="bar">
                  <div
                    class="inbetween"
                    :style="{
                      'margin-left': getInbetweenMin(item) + '0%',
                      'margin-right': 10 - getInbetweenMax(item) + '0%'
                    }"
                  >
                    <div class="start"></div>
                    <div class="end"></div>
                  </div>
                </div>
                <div class="profile-wrapper">
                  <div
                    class="profile profile-right"
                    :style="{ right: 10 - item.partnerPosition + '0%' }"
                  >
                    <div class="score">{{ item.partnerPosition }}</div>
                    <div class="photo" :style="updatePartnerPhotoView()"></div>
                  </div>
                </div>
                <div class="extra">
                  <span>{{ getLabelItem(item.labels, 0) }}</span>
                  <span>{{ getLabelItem(item.labels, 1) }}</span>
                </div>
              </div>
              <div class="desc">{{ item.description }}</div>
            </div>
          </div>
          <div class="padding-area"></div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import '@/css/swiper.min.css'
import ConnectionService from '@/services/connection-service'
import CompLoading from '@/components/CompLoading.vue'

export default {
  name: 'ConnectionDetails',
  mixins: [common],
  components: {
    Swiper,
    SwiperSlide,
    CompLoading
  },
  data() {
    return {
      isLoading: false,

      userName: 'User Name',
      userType: 'User Type',
      content: '',
      detailList: [],
      connectionSeqId: this.$route.params.connectionSeqId,
      myImage: '',
      partnerImage: '',
      typeColor: '',

      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>'
          }
        }
      }
    }
  },
  created() {
    this.$parent.setHeader('Connection Details')
    this.$parent.headerBack = true
    this.$parent.setBottomTab(false)
    this.getConnectionDetail()
    this.$store.state.selectedSubMenu = 'connected'
  },
  methods: {
    getInbetweenMin(item) {
      if (
        this.isEmpty(item) ||
        this.isEmpty(item.myPosition) ||
        this.isEmpty(item.partnerPosition)
      ) {
        return 0
      }

      const myPos = item.myPosition
      const partnerPos = item.partnerPosition
      return myPos > partnerPos ? partnerPos : myPos
    },
    getInbetweenMax(item) {
      if (
        this.isEmpty(item) ||
        this.isEmpty(item.myPosition) ||
        this.isEmpty(item.partnerPosition)
      ) {
        return 0
      }

      const myPos = item.myPosition
      const partnerPos = item.partnerPosition
      return myPos > partnerPos ? myPos : partnerPos
    },
    getConnectionDetail() {
      this.isLoading = true

      ConnectionService.getConnectionDetail(this.connectionSeqId).then(
        ({ resultCode, resultData }) => {
          this.isLoading = false

          if (resultCode === 0) {
            this.userName = resultData.partnerName
            this.userType = resultData.type
            this.content = resultData.content1 + ' ' + resultData.content2
            this.myImage = resultData.myImage
            this.partnerImage = resultData.partnerImage
            this.detailList.push(resultData.sec1)
            this.detailList.push(resultData.sec2)
            this.detailList.push(resultData.sec3)
            this.detailList.push(resultData.sec4)
            this.detailList.push(resultData.sec5)
            this.detailList.push(resultData.sec6)
            this.detailList.push(resultData.sec7)
            this.detailList.push(resultData.sec8)
            if (this.userType === 'Peer') {
              this.typeColor = 'type-1'
            } else if (this.userType === 'Coworker') {
              this.typeColor = 'type-2'
            } else if (this.userType === 'Employee') {
              this.typeColor = 'type-3'
            } else if (this.userType === 'Supervisor') {
              this.typeColor = 'type-4'
            }
          }
        }
      )
    },
    getLabelItem(label, idx) {
      if (this.isEmpty(label)) return

      const labels = label.split('-')
      if (labels && labels.length > idx) return labels[idx]
      return 'Unknown'
    },
    updatePartnerPhotoView() {
      return {
        backgroundImage: `url(data:image/png;base64,${this.partnerImage})`
      }
    },
    updateMyPhotoView() {
      return {
        backgroundImage: `url(data:image/png;base64,${this.myImage})`
      }
    }
  }
}
</script>

<style lang="scss" src="@/scss/connections.scss" scope></style>
